import { Box, SystemIcon, Typography } from '@wishket/design-system';
import React from 'react';

import { Item } from './RemovableList.types';

export const BottomSheetRemovableItem = ({ text, onClick, onRemove }: Item) => {
  return (
    <Box className="flex items-center gap-4">
      <SystemIcon name="medium_question" className="shrink-0 text-primary" />
      <Box className="flex flex-auto items-center justify-between truncate">
        <Typography
          variant="body1"
          className="cursor-pointer truncate text-w-gray-700"
          onClick={onClick}
        >
          {text}
        </Typography>
      </Box>
      <Box
        onClick={onRemove}
        className="cursor-pointer"
        data-testid="bottom-sheet-removable-list-trash-icon"
      >
        <SystemIcon name="medium_trash" className="text-w-gray-600" />
      </Box>
    </Box>
  );
};

interface DefaultBottomSheetRemovableItemProps {
  onClick: () => void;
}

export const DefaultBottomSheetRemovableItem = ({
  onClick,
}: DefaultBottomSheetRemovableItemProps) => {
  return (
    <button className="flex items-center gap-4 desktop:py-4" onClick={onClick}>
      <SystemIcon
        name="medium_question_new"
        className="shrink-0 text-primary"
        solid
      />
      <Box className="flex flex-auto items-center justify-between truncate">
        <Typography variant="body1" className="truncate text-w-gray-700">
          새로운 질문
        </Typography>
      </Box>
    </button>
  );
};
